import {useAttendeeVariables} from 'Event'
import styled from 'styled-components'
import {useTemplate} from 'Event/TemplateProvider'
import Content from 'lib/ui/form/TextEditor/Content'
import Configurable from 'organization/Event/Configurable'
import React from 'react'
import WaiverConfig from 'Event/Step2/Waivers/Description/WaiverConfig'

export default function Description() {
  const v = useAttendeeVariables()

  const {waiver} = useTemplate()

  return (
    <Configurable>
      <WaiverConfig />
      <StyledContent>{v(waiver.description)}</StyledContent>
    </Configurable>
  )
}

const StyledContent = styled(Content)`
  max-height: 100%;
  overflow-y: auto;
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 24px;

  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 32px;
  }
`
